import React from 'react';
import { useAppState } from '../src/contexts/AppStateContext';

const OrgSwitcher = () => {
    const { organizations, currentOrganization, switchOrganization, loading } = useAppState();

    if (loading) {
        return <div className="text-sm text-gray-500">Loading organizations...</div>;
    }

    if (!organizations || organizations.length === 0) {
        return <div className="text-sm text-gray-500">No organizations available</div>;
    }

    // No point in showing a switcher when there is nothing to switch to
    if (organizations.length === 1) {
        return null;
    }

    return (
        <div className="mb-4">
            <label htmlFor="org-select" className="block text-sm font-medium text-gray-700 mb-1">
                Organization:
            </label>
            <select
                id="org-select"
                value={currentOrganization?.id || ''}
                onChange={(e) => switchOrganization(e.target.value)}
                disabled={loading}
                className="block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
                {organizations.map(org => (
                    <option key={org.id} value={org.id}>
                        {org.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default OrgSwitcher;